var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

/**
 * InvalidAccessError
 */
var InvalidAccessError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(InvalidAccessError, _Error);

  function InvalidAccessError(message) {
    _classCallCheck(this, InvalidAccessError);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidAccessError).call(this, message));
  }

  return InvalidAccessError;
}(_wrapNativeSuper(Error));
/**
 * Export
 */


module.exports = InvalidAccessError;